// Group GROUP 7. Coordination and Information Structure
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group7Data = {
  "id": "group_7",
  "title": {
    "tc": "並列與信息結構",
    "sc": "并列与信息结构",
    "en": "Coordination and Information Structure"
  },
  "subtitle": {
    "tc": "Coordination and Information Structure",
    "sc": "Coordination and Information Structure",
    "en": "Coordination and Information Structure"
  },
  "icon": "🔗",
  "difficulty": "intermediate",
  "color": "from-blue-500 to-blue-600",
  "topics": [
    {
      "id": "coordination",
      "title": {
        "tc": "並列句",
        "sc": "并列句",
        "en": "Coordination"
      },
      "description": {
        "tc": "學習並列句的結構和用法",
        "sc": "学习并列句的结构和用法",
        "en": "Learn the structure and usage of coordination"
      },
      "icon": "🔗",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "coord_1",
          "sentence": "I was tired, but I kept working.",
          "analysis": "I (S) was (V) tired (C), but (conj) I (S) kept working (V).",
          "translation": {
            "tc": "我很累，但我繼續工作。",
            "sc": "我很累，但我继续工作。",
            "en": "I was tired, but I kept working."
          }
        },
        {
          "id": "coord_2",
          "sentence": "She cooked, and he washed the dishes.",
          "analysis": "She (S) cooked (V), and (conj) he (S) washed (V) the dishes (O).",
          "translation": {
            "tc": "她做飯，他洗碗。",
            "sc": "她做饭，他洗碗。",
            "en": "She cooked, and he washed the dishes."
          }
        },
        {
          "id": "coord_3",
          "sentence": "We can stay or we can go.",
          "analysis": "We (S) can stay (V) or (conj) we (S) can go (V).",
          "translation": {
            "tc": "我們可以留下或離開。",
            "sc": "我们可以留下或离开。",
            "en": "We can stay or we can go."
          }
        },
        {
          "id": "coord_4",
          "sentence": "He spoke quietly, yet everyone listened.",
          "analysis": "He (S) spoke (V) quietly (M), yet (conj) everyone (S) listened (V).",
          "translation": {
            "tc": "他輕聲說話，但每個人都聽著。",
            "sc": "他轻声说话，但每个人都听着。",
            "en": "He spoke quietly, yet everyone listened."
          }
        },
        {
          "id": "coord_5",
          "sentence": "Finish your work, and you can leave.",
          "analysis": "Finish (V) your work (O), and (conj) you (S) can leave (V).",
          "translation": {
            "tc": "完成你的工作，你就可以離開。",
            "sc": "完成你的工作，你就可以离开。",
            "en": "Finish your work, and you can leave."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：對等連接 and/but/or/so/yet；注意逗號與獨立子句。",
        "sc": "要点：对等连接 and/but/or/so/yet；注意逗号与独立子句。",
        "en": "Key points: coordinating conjunctions and/but/or/so/yet; pay attention to commas with independent clauses."
      }
    },
    {
      "id": "parallelism",
      "title": {
        "tc": "平行結構",
        "sc": "平行结构",
        "en": "Parallelism"
      },
      "description": {
        "tc": "學習平行結構的用法",
        "sc": "学习平行结构的用法",
        "en": "Learn the usage of parallelism"
      },
      "icon": "⚖️",
      "difficulty": "intermediate",
      "examples": [
        {
          "id": "parallel_1",
          "sentence": "She likes reading, cooking, and hiking.",
          "analysis": "She (S) likes (V) reading/cooking/hiking (O).",
          "translation": {
            "tc": "她喜歡閱讀、烹飪和遠足。",
            "sc": "她喜欢阅读、烹饪和远足。",
            "en": "She likes reading, cooking, and hiking."
          }
        },
        {
          "id": "parallel_2",
          "sentence": "He promised to plan, to budget, and to report.",
          "analysis": "He (S) promised (V) to plan/to budget/to report (O).",
          "translation": {
            "tc": "他承諾要計劃、預算和報告。",
            "sc": "他承诺要计划、预算和报告。",
            "en": "He promised to plan, to budget, and to report."
          }
        },
        {
          "id": "parallel_3",
          "sentence": "The policy is clear, consistent, and fair.",
          "analysis": "The policy (S) is (V) clear/consistent/fair (C).",
          "translation": {
            "tc": "這個政策是清楚、一致和公平的。",
            "sc": "这个政策是清楚、一致和公平的。",
            "en": "The policy is clear, consistent, and fair."
          }
        },
        {
          "id": "parallel_4",
          "sentence": "We aim to reduce costs, improve quality, and shorten cycles.",
          "analysis": "We (S) aim (V) to reduce/to improve/to shorten (O).",
          "translation": {
            "tc": "我們的目標是降低成本、提高質量和縮短週期。",
            "sc": "我们的目标是降低成本、提高质量和缩短周期。",
            "en": "We aim to reduce costs, improve quality, and shorten cycles."
          }
        },
        {
          "id": "parallel_5",
          "sentence": "They were laughing, cheering, and clapping.",
          "analysis": "They (S) were (V) laughing/cheering/clapping (V-ing).",
          "translation": {
            "tc": "他們在笑、歡呼和鼓掌。",
            "sc": "他们在笑、欢呼和鼓掌。",
            "en": "They were laughing, cheering, and clapping."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：形式一致避免錯誤平行；三項以上用逗號與 and。",
        "sc": "要点：形式一致避免错误平行；三项以上用逗号与 and。",
        "en": "Key points: consistent form avoids faulty parallelism; three or more items use commas and and."
      }
    }
  ]
};
